/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import * as React from 'react';

import { Dialog, DialogContentText, DialogContent, DialogActions, Button } from '@material-ui/core';

interface AppProps {
  error: boolean,
}
class DialogError extends React.Component<AppProps> {
  constructor(props: AppProps) {
    super(props, {});
  }


  closeError = () => {
    window.open('https://www.google.pl/', '_self');
  }

  //PM 2021-08-05
  render() {
    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="sm"
        open={true}
        fullWidth
      >
        <DialogContent >
          {this.props.error ?
            <>
              <DialogContentText variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "1rem", padding: " 10px 0px 20px 0px" }}>
                <b>{"pobieranie danych..."}</b>
              </DialogContentText>
              <DialogContentText variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "1rem", padding: " 10px 0px 20px 0px" }}>
                <b>{"przepraszamy - wystąpił problem z przekierowaniem"}</b>
              </DialogContentText>
            </>
            :
            <>
              <DialogContentText variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "1rem" }}>
                <b>{"pobieranie danych..."}</b>
              </DialogContentText>
              {/* <Typography variant="h6" component="h2" color="primary" style={{ textAlign: "center", fontSize: "1rem", padding: " 10px 0px 20px 0px" }}>
                        <b>{"proszę czekać"}</b>
                    </Typography> */}
            </>
          }
          <div style={{ textAlign: "center" }}>
            {/* <ResponsiveImgMaterialUi style={{ maxWidth: window.innerWidth > 600 ? "400px" : "270px", margin: "auto" }}
              xs={this.props.logoUrl}
              md={this.props.logoUrl}
              lg={this.props.logoUrl}
            /> */}
          </div>
        </DialogContent >
        <DialogActions >
          {this.props.error ?
            <Button onClick={() => this.closeError()} variant="outlined" size="small" color="secondary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b>OK</b>
            </Button>
            : null}
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogError
